import {twMerge} from 'tailwind-merge';
import type {StyleHTMLAttributes} from 'react';

type Props = {
  progress: number;
  className?: string;
  color?: string;
};

const ProgressCircle = ({progress = 0, className, color = 'var(--purple)'}: Props) => {
  return (
    <div
      style={{'--progress': progress, '--progress-color': color} as StyleHTMLAttributes<HTMLDivElement>}
      className={twMerge('rounded-full w-[22px] h-[22px] border-2 border-(--progress-color) shrink-0', className)}
    >
      <div className="relative w-[14px] h-[14px] ml-[2px] mt-[2px] rounded-full before:content-[''] before:absolute before:rounded-full before:inset-0 before:bg-[conic-gradient(var(--progress-color)_calc(var(--progress)*1%),#0000_0)]" />
    </div>
  );
};

export default ProgressCircle;
